import { render, staticRenderFns } from "./UpdateDate.vue?vue&type=template&id=68463dba&"
import script from "./UpdateDate.vue?vue&type=script&lang=js&"
export * from "./UpdateDate.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports